import { Component, Inject, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { OverlayContainer } from '@angular/cdk/overlay';

@Component({
  selector: 'app-incident-modal-v2',
  templateUrl: './incident-modal-v2.component.html',
  styleUrls: ['./incident-modal-v2.component.scss'],
  providers: [{ provide: MatPaginatorIntl, useClass: MatPaginatorIntl }],
})
export class IncidentModalV2Component implements OnInit, AfterViewInit, OnDestroy {
  public eventModalProps: any = {};
  public isOpen: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<IncidentModalV2Component>,
    private overlayContainer: OverlayContainer
  ) {}

  ngOnInit(): void {
    this.eventModalProps = {
      isOpen: this.isOpen,
      onClose: this.onClose,
      incidents: this.data.allEvents,
      currentIndex: this.data.currentIndex,
      feedbackScreen: false,
      pageIndex: this.data.pageIndex,
      batchSize: this.data.batchSize,
    };
  }

  ngAfterViewInit(): void {
    const container = this.overlayContainer.getContainerElement();
    container.style.zIndex = '999';
  }

  ngOnDestroy(): void {
    const container = this.overlayContainer.getContainerElement();
    container.style.zIndex = '';
  }

  public onClose = (updatedIncidents: any[]) => {
    this.isOpen = false;
    this.dialogRef.close(updatedIncidents);
  };
}
